import { render, staticRenderFns } from "./RecentGames.vue?vue&type=template&id=21b190f3&scoped=true&"
import script from "./RecentGames.vue?vue&type=script&lang=js&"
export * from "./RecentGames.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./RecentGames.vue?vue&type=style&index=1&id=21b190f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b190f3",
  null
  
)

export default component.exports